function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styles from './Drawer.module.scss';
import cs from 'classnames';
import ButtonLabel from '../Buttons/ButtonLabel/ButtonLabel';
import AdditionalIntl from '../I18n/AdditionalIntl/AdditionalIntl';
import normalizeLocaleData from '../utils/i18n/normalizeLocaleData';
import uuid from '../utils/uuid';
import useFocusTrap from '../hooks/useFocusTrap';
import en from './locales/Drawer.en.json';
import { injectIntl } from 'react-intl';
import { formatI18n } from '../I18n/I18n/I18n';
import useStickyBottom from './useStickyBottom';
import DrawerContext from './DrawerContext/DrawerContext';
var RED_ZONE_IDS = ['header', 'content', 'react-root--legacy'];
var MESSAGES = normalizeLocaleData(en, '@dm/components.drawer');
function Drawer(_ref) {
  var children = _ref.children,
    _ref$focusTrapPaused = _ref.focusTrapPaused,
    focusTrapPaused = _ref$focusTrapPaused === void 0 ? false : _ref$focusTrapPaused,
    forceOpen = _ref.forceOpen,
    _ref$hasCollapseButto = _ref.hasCollapseButton,
    hasCollapseButton = _ref$hasCollapseButto === void 0 ? true : _ref$hasCollapseButto,
    _ref$hasExpandButton = _ref.hasExpandButton,
    hasExpandButton = _ref$hasExpandButton === void 0 ? true : _ref$hasExpandButton,
    _ref$initialCollapsed = _ref.initialCollapsed,
    initialCollapsed = _ref$initialCollapsed === void 0 ? false : _ref$initialCollapsed,
    intl = _ref.intl,
    labelledby = _ref.labelledby,
    name = _ref.name,
    namespace = _ref.namespace,
    _ref$allowBodyScroll = _ref.allowBodyScroll,
    allowBodyScroll = _ref$allowBodyScroll === void 0 ? true : _ref$allowBodyScroll,
    onCollapse = _ref.onCollapse,
    onExpand = _ref.onExpand,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? false : _ref$show,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'small' : _ref$width;
  var _useState = useState(initialCollapsed),
    _useState2 = _slicedToArray(_useState, 2),
    isCollapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    scroll = _useState4[0],
    setScroll = _useState4[1];
  var contentId = "drawer-".concat(uuid());
  var drawerRef = useRef(null);
  var screenRef = useRef(null);
  var contentRef = useRef(null);
  var footerRef = useRef(null);
  useStickyBottom(contentRef, footerRef);
  useFocusTrap(drawerRef, {
    activate: focusTrapPaused ? false : show && !isCollapsed,
    allowOutsideClick: function allowOutsideClick(e) {
      var screen = screenRef.current;
      return !(screen && screen.contains(e.target));
    },
    allowOutsideFocus: function allowOutsideFocus(e) {
      return RED_ZONE_IDS.every(function (id) {
        var el = document.getElementById(id);
        if (el) {
          return !el.contains(e.target);
        } else {
          return true;
        }
      });
    }
  });
  useEffect(function () {
    var ref = contentRef.current;
    if (ref && !isCollapsed) {
      // set scroll position back to what it was
      ref.scrollTop = scroll;
    }
  }, [isCollapsed, scroll]);
  useEffect(function () {
    if (isCollapsed) {
      onCollapse && onCollapse();
    } else {
      onExpand && onExpand();
    }
  }, [isCollapsed, onExpand, onCollapse]);
  useEffect(function () {
    if (forceOpen && isCollapsed) {
      setCollapsed(false);
    }
  }, [forceOpen, isCollapsed]);
  useEffect(function () {
    if (!isCollapsed && !allowBodyScroll) {
      document.body.classList.add(styles['no-scroll']);
    }
    return function () {
      document.body.classList.remove(styles['no-scroll']);
    };
  }, [isCollapsed, allowBodyScroll]);
  var toggleCollapse = useCallback(function () {
    var ref = contentRef.current;
    if (ref && !isCollapsed) {
      // saves scroll position for re-opening
      setScroll(ref.scrollTop);
    }
    setCollapsed(!isCollapsed);
  }, [contentRef, isCollapsed, setCollapsed]);
  var label = formatI18n(intl, name);
  var style = useMemo(function () {
    if (width !== 'small' && width !== 'large') {
      return {
        maxWidth: width
      };
    } else {
      return undefined;
    }
  }, [width]);
  var autoClass = useMemo(function () {
    if (namespace) {
      var stateModifier = isCollapsed ? 'collapsed' : 'expanded';
      return "auto-".concat(namespace, "-drawer auto-").concat(namespace, "-drawer--").concat(stateModifier);
    }
  }, [namespace, isCollapsed]);
  var drawerContext = useMemo(function () {
    var titleId = uuid();
    return {
      footerRef: footerRef,
      label: label,
      titleId: titleId,
      toggleCollapse: toggleCollapse
    };
  }, [footerRef, label, toggleCollapse]);
  if (show) {
    return /*#__PURE__*/React.createElement(AdditionalIntl, {
      messages: MESSAGES,
      path: "Drawer/locales/Drawer",
      namespace: "@dm/components.drawer"
    }, /*#__PURE__*/React.createElement(DrawerContext.Provider, {
      /* @ts-ignore */value: drawerContext
    }, !isCollapsed && /*#__PURE__*/React.createElement("div", {
      ref: screenRef,
      className: styles.screen
    }), /*#__PURE__*/React.createElement("div", {
      ref: drawerRef,
      role: isCollapsed ? undefined : 'dialog',
      "aria-labelledby": isCollapsed ? undefined : labelledby || drawerContext.titleId,
      className: cs(styles.drawer, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles["drawer--".concat(width)], !style), styles['collapsed-has-expand-button'], isCollapsed && hasExpandButton), styles.collapsed, isCollapsed && !hasExpandButton), styles.expanded, !isCollapsed), autoClass),
      style: style
    }, hasCollapseButton && /*#__PURE__*/React.createElement("button", {
      onClick: toggleCollapse,
      tabIndex: isCollapsed && !hasExpandButton ? -1 : undefined,
      className: cs(styles.button, _defineProperty({}, styles['button--expanded'], !isCollapsed)),
      "aria-expanded": !isCollapsed,
      "aria-controls": contentId
    }, /*#__PURE__*/React.createElement("span", {
      className: cs(styles.arrow, _defineProperty(_defineProperty({}, styles['arrow--collapsed'], isCollapsed), styles['arrow--expanded'], !isCollapsed)),
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      focusable: "false"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M20 11L7.83 11 13.42 5.41 12 4 4 12 12 20 13.41 18.59 7.83 13 20 13z",
      transform: "translate(-4 -4)",
      fillRule: "nonzero"
    }))), /*#__PURE__*/React.createElement(ButtonLabel, {
      hideLabel: true,
      i18n: {
        id: '@dm/components.drawer.toggle',
        values: {
          name: label
        }
      }
    })), /*#__PURE__*/React.createElement("div", {
      id: contentId,
      ref: contentRef
      // aria-controls seems to make this a tabIndex="0" which we don't want
      ,
      tabIndex: -1,
      className: cs(styles.content, _defineProperty(_defineProperty({}, styles["content--expanded"], !isCollapsed), styles['content--collapsed'], isCollapsed))
    }, !isCollapsed && (typeof children === 'function' ? children(toggleCollapse, footerRef) : children)))));
  } else {
    return null;
  }
}
export default injectIntl(Drawer);